import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#030E1A",
      "fill-rule": "evenodd",
      d: "M7 19c-.551 0-1-.449-1-1s.449-1 1-1h11v2zM19 3H7C5.346 3 4 4.346 4 6v12c0 1.654 1.346 3 3 3h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }